import React from 'react';
import { Outlet } from 'react-router-dom';

export const BareShell: React.FC = () => (
  <div className="bare-shell">
    <Outlet />
  </div>
);

export default BareShell;
